module.exports = __webpack_public_path__ + "static/media/moons_cuanto_cuestan-1800.4761c3e4.jpg";